import { TrendingUp, Send, CheckCircle, AlertCircle } from 'lucide-react';

interface BroadcastStatsProps {
    totalBroadcasts: number;
    totalSent: number;
    averageSuccessRate: number;
    pendingCount: number;
}

export default function BroadcastStats({
    totalBroadcasts,
    totalSent,
    averageSuccessRate,
    pendingCount
}: BroadcastStatsProps) {
    const stats = [
        {
            label: 'Total de Broadcasts',
            value: totalBroadcasts,
            icon: TrendingUp,
            text: 'text-blue-600',
            lightBg: 'bg-blue-50',
            border: 'border-blue-100',
        },
        {
            label: 'Mensagens Enviadas',
            value: totalSent.toLocaleString('pt-BR'),
            icon: Send,
            text: 'text-emerald-600',
            lightBg: 'bg-emerald-50',
            border: 'border-emerald-100',
        },
        {
            label: 'Taxa de Sucesso Média',
            value: `${averageSuccessRate.toFixed(1)}%`,
            icon: CheckCircle,
            text: 'text-cyan-600',
            lightBg: 'bg-cyan-50',
            border: 'border-cyan-100',
        },
        {
            label: 'Pendentes',
            value: pendingCount,
            icon: AlertCircle,
            text: 'text-amber-600',
            lightBg: 'bg-amber-50',
            border: 'border-amber-100',
        }
    ];

    return (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
            {stats.map((stat, index) => {
                const Icon = stat.icon;
                return (
                    <div
                        key={index}
                        className={`relative overflow-hidden rounded-xl border ${stat.border} bg-white p-5 hover:shadow-lg transition-all duration-300 group`}
                    >
                        <div className={`absolute top-0 right-0 w-32 h-32 ${stat.lightBg} rounded-full blur-3xl opacity-30 -mr-16 -mt-16 group-hover:opacity-50 transition-opacity`} />

                        <div className="relative z-10">
                            <div className="flex items-center justify-between mb-4">
                                <div className={`p-2.5 rounded-lg ${stat.lightBg}`}>
                                    <Icon className={`h-5 w-5 ${stat.text}`} strokeWidth={1.5} />
                                </div>
                            </div>
                            <h3 className="text-sm font-medium text-gray-600 mb-1">{stat.label}</h3>
                            <p className="text-2xl font-bold text-gray-900">{stat.value}</p>
                        </div>
                    </div>
                );
            })}
        </div>
    );
}